import React, { useState, useEffect } from 'react'
import { getStudentIdData as getStudentColleges } from '../../lib/studentcollegelistview'
import { getDataWithTypeForSelect } from '../../lib/parameters'

const CollegeListForProfile = ({ studentId }) => {
	const [collegelist, setCollegeList] = useState([])
	const [parameters, setParameters] = useState([])
	const [loading, setLoading] = useState(true)
	const [isDarkMode, setIsDarkMode] = useState(false)

	async function GetData() {
		try {
			setLoading(true)
			const colleges = await getStudentColleges(studentId)
			setCollegeList(colleges)

			const parameterData = await getDataWithTypeForSelect('DESIRED_COLLEGES')
			setParameters(parameterData)
		} catch (error) {
			console.error('Error fetching college data:', error)
		} finally {
			setLoading(false)
		}
	}

	function getRank(ranks, key) {
		try {
			const result = Object.entries(JSON.parse(ranks)).filter((item) => item[0] === key.toString())
			return result.length > 0 ? result[0][1] : '-'
		} catch (error) {
			return '-'
		}
	}

	useEffect(() => {
		if (studentId) {
			GetData()
		}
	}, [studentId])

	useEffect(() => {
		const checkDarkMode = () => {
			setIsDarkMode(document.body.classList.contains('dark-only'))
		}
		checkDarkMode()
		const observer = new MutationObserver(checkDarkMode)
		observer.observe(document.body, {
			attributes: true,
			attributeFilter: ['class'],
		})
		return () => observer.disconnect()
	}, [])

	const tableStyle = {
		backgroundColor: isDarkMode ? '#262932' : '#fff',
		color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
	}

	return (
		<div
			className="card mb-4 shadow-sm"
			style={{
				borderRadius: '8px',
				backgroundColor: isDarkMode ? '#262932' : '#fff',
			}}
		>
			<div
				className="card-header border-bottom"
				style={{ backgroundColor: isDarkMode ? '#262932' : '#fff' }}
			>
				<h5
					className="mb-0"
					style={{
						color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
					}}
				>
					List Of Desired Colleges
				</h5>
			</div>
			<div
				className="card-body"
				style={{ backgroundColor: isDarkMode ? '#262932' : '#fff' }}
			>
				{loading ? (
					<div className="text-center p-4">
						<div className="spinner-border" role="status">
							<span className="visually-hidden">Loading...</span>
						</div>
						<p
							className="mt-2"
							style={{
								color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
							}}
						>
							Loading colleges...
						</p>
					</div>
				) : (
					<div className="table-responsive">
						<table
							className="table table-striped table-hover mb-0"
							style={tableStyle}
						>
							<thead>
								<tr>
									<th
										style={{
											backgroundColor: isDarkMode ? '#2a2d35' : '#f8f9fa',
											color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
											borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#dee2e6',
										}}
									></th>
									{collegelist && collegelist.length > 0 ? (
										collegelist.map((clist) => (
											<th
												key={clist.id}
												className="text-center"
												style={{
													backgroundColor: isDarkMode ? '#2a2d35' : '#f8f9fa',
													color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
													borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#dee2e6',
												}}
											>
												{clist.collegename}
											</th>
										))
									) : (
										<th
											className="text-center"
											style={{
												backgroundColor: isDarkMode ? '#2a2d35' : '#f8f9fa',
												color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
												borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#dee2e6',
											}}
										>
											No colleges selected
										</th>
									)}
								</tr>
							</thead>
							<tbody>
								{parameters && parameters.length > 0 ? (
									parameters.map((prm) => (
										<tr
											key={prm.value}
											style={{
												backgroundColor: isDarkMode ? '#262932' : '#fff',
											}}
										>
											<td
												className="fw-bold"
												style={{
													color: isDarkMode ? 'rgba(255, 255, 255, 0.8)' : 'inherit',
													borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#dee2e6',
												}}
											>
												{prm.label}
											</td>
											{collegelist && collegelist.length > 0 ? (
												collegelist.map((c2list) => (
													<td
														key={c2list.id}
														className="text-center"
														style={{
															color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
															borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#dee2e6',
														}}
													>
														{getRank(c2list.rankvalue, prm.value)}
													</td>
												))
											) : (
												<td
													className="text-center"
													style={{
														color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'inherit',
														borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#dee2e6',
													}}
												>
													-
												</td>
											)}
										</tr>
									))
								) : (
									<tr
										style={{
											backgroundColor: isDarkMode ? '#262932' : '#fff',
										}}
									>
										<td
											colSpan={collegelist.length + 1}
											className="text-center"
											style={{
												color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : '#6c757d',
											}}
										>
											No data available
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</div>
	)
}

export { CollegeListForProfile }
